import React from 'react';
import {Trans} from '@ui/i18n/trans';
import {Button} from '@ui/buttons/button';
import {Link} from 'react-router';
import {CheckCircleIcon} from '@ui/icons/material/CheckCircle';

export function OnboardingDoneStep() {
  return (
    <div className="flex flex-col items-center py-24 text-center">
      <CheckCircleIcon className="mb-20 text-positive" size="text-6xl" />
      <h1 className="mb-12 text-2xl font-semibold">
        <Trans message="Welcome aboard!" />
      </h1>
      <p className="mb-32 max-w-sm text-sm text-muted">
        <Trans message="Your account has been created successfully. You're all set to start exploring." />
      </p>
      <Button
        variant="flat"
        color="primary"
        size="lg"
        elementType={Link}
        to="/"
      >
        <Trans message="Go to homepage" />
      </Button>
    </div>
  );
}
